
    import './styles.scoped.css';
    export default {
  "arrow": "awsui_arrow_xjuzf_777hs_185",
  "arrow-outer": "awsui_arrow-outer_xjuzf_777hs_189",
  "arrow-inner": "awsui_arrow-inner_xjuzf_777hs_189",
  "arrow-position-right-top": "awsui_arrow-position-right-top_xjuzf_777hs_220",
  "arrow-position-right-bottom": "awsui_arrow-position-right-bottom_xjuzf_777hs_220",
  "arrow-position-left-top": "awsui_arrow-position-left-top_xjuzf_777hs_223",
  "arrow-position-left-bottom": "awsui_arrow-position-left-bottom_xjuzf_777hs_223",
  "arrow-position-top-center": "awsui_arrow-position-top-center_xjuzf_777hs_226",
  "arrow-position-top-right": "awsui_arrow-position-top-right_xjuzf_777hs_226",
  "arrow-position-top-left": "awsui_arrow-position-top-left_xjuzf_777hs_226",
  "arrow-position-top-responsive": "awsui_arrow-position-top-responsive_xjuzf_777hs_226",
  "arrow-position-bottom-center": "awsui_arrow-position-bottom-center_xjuzf_777hs_229",
  "arrow-position-bottom-right": "awsui_arrow-position-bottom-right_xjuzf_777hs_229",
  "arrow-position-bottom-left": "awsui_arrow-position-bottom-left_xjuzf_777hs_229",
  "arrow-position-bottom-responsive": "awsui_arrow-position-bottom-responsive_xjuzf_777hs_229",
  "body": "awsui_body_xjuzf_777hs_325",
  "body-overflow-visible": "awsui_body-overflow-visible_xjuzf_777hs_344",
  "variant-annotation": "awsui_variant-annotation_xjuzf_777hs_348",
  "body-size-small": "awsui_body-size-small_xjuzf_777hs_353",
  "fixed-width": "awsui_fixed-width_xjuzf_777hs_356",
  "body-size-medium": "awsui_body-size-medium_xjuzf_777hs_360",
  "body-size-large": "awsui_body-size-large_xjuzf_777hs_367",
  "has-dismiss": "awsui_has-dismiss_xjuzf_777hs_379",
  "dismiss": "awsui_dismiss_xjuzf_777hs_384",
  "dismiss-control": "awsui_dismiss-control_xjuzf_777hs_391",
  "header-row": "awsui_header-row_xjuzf_777hs_395",
  "header": "awsui_header_xjuzf_777hs_395",
  "content": "awsui_content_xjuzf_777hs_417",
  "content-overflow-visible": "awsui_content-overflow-visible_xjuzf_777hs_424",
  "container": "awsui_container_xjuzf_777hs_436",
  "container-arrow": "awsui_container-arrow_xjuzf_777hs_444",
  "container-arrow-position-right-top": "awsui_container-arrow-position-right-top_xjuzf_777hs_448",
  "container-arrow-position-right-bottom": "awsui_container-arrow-position-right-bottom_xjuzf_777hs_448",
  "container-arrow-position-left-top": "awsui_container-arrow-position-left-top_xjuzf_777hs_460",
  "container-arrow-position-left-bottom": "awsui_container-arrow-position-left-bottom_xjuzf_777hs_460",
  "container-arrow-position-top-center": "awsui_container-arrow-position-top-center_xjuzf_777hs_472",
  "container-arrow-position-top-right": "awsui_container-arrow-position-top-right_xjuzf_777hs_472",
  "container-arrow-position-top-left": "awsui_container-arrow-position-top-left_xjuzf_777hs_472",
  "container-arrow-position-top-responsive": "awsui_container-arrow-position-top-responsive_xjuzf_777hs_472",
  "container-arrow-position-bottom-center": "awsui_container-arrow-position-bottom-center_xjuzf_777hs_488",
  "container-arrow-position-bottom-right": "awsui_container-arrow-position-bottom-right_xjuzf_777hs_492",
  "container-arrow-position-bottom-left": "awsui_container-arrow-position-bottom-left_xjuzf_777hs_496",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_xjuzf_777hs_1",
  "refresh": "awsui_refresh_xjuzf_777hs_614",
  "root": "awsui_root_xjuzf_777hs_636",
  "trigger": "awsui_trigger_xjuzf_777hs_648",
  "trigger-type-text": "awsui_trigger-type-text_xjuzf_777hs_655",
  "trigger-inner-text": "awsui_trigger-inner-text_xjuzf_777hs_684"
};
  